import React from 'react'

const Amex = () => {
  return (
    <div className="icon--amex-card">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="6"
        viewBox="0 0 13 6"
        fill="none"
      >
        <path
          d="M11.66 0.5H11L9.51 3.69L8 0.5H6V4.73L4.08 0.5H2.18L0 5.5H1.49L1.94 4.39H4.28L4.76 5.5H7.25V1.89L8.92 5.5H10.13L11.66 2.19V5.5H13V0.5H11.66ZM2.41 3.25L3.08 1.59L3.79 3.25H2.41Z"
          fill="currentColor"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="6"
        viewBox="0 0 11 6"
        fill="none"
      >
        <path
          d="M11 0.5H9.24L7.82 2L6.43 0.5H0.92V5.5H6.32L7.8 3.92L9.24 5.5H11L8.69 3L11 0.5ZM5 5V4.35H2.21V3.56H5V2.43H2.21V1.64H5V0.889999L6.93 3L5 5Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}

export default Amex
